import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
  selector: 'app-subscribe-form',
  templateUrl: './subscribe-form.component.html',
  styleUrls: ['./subscribe-form.component.scss'],
})
export class SubscribeFormComponent implements OnInit {
  @Input() showCloseBtn = false;
  @Input() emailDisabled = false;
  @Input() wallet = '';
  @Input() email = '';
  @Input() notifyOnUnlock = true;
  @Input() monthlySummary = true;

  @Output() onClose = new EventEmitter();
  @Output() onSave = new EventEmitter();

  saving = false;

  constructor() {}

  ngOnInit(): void {}

  save() {
    this.saving = true;
    this.onSave.emit({
      walletId: this.wallet,
      email: this.email,
      notifyOnUnlock: this.notifyOnUnlock,
      monthlySummary: this.monthlySummary,
    });
  }
}
